module.exports = __webpack_public_path__ + "static/media/shrikeWithWords.3f0960fb.png";